import React from 'react';
import { twMerge } from 'tailwind-merge';

import { InsightsOverlay } from '@/features/navigation/bottom-navigation/toolkit/insightsOverlay';
import useBreakpoints from '@/hooks/useBreakpoint';

type Props = {
  open: boolean;
};

export const InsightsOverlayPopover: React.FC<Props> = ({ open }) => {
  const { isMobile } = useBreakpoints();

  return (
    <div
      className={twMerge(
        'z-[100] flex w-[360px] flex-col bg-white  py-4',
        isMobile && 'max-w-[calc(100dvw-70px)]',
        !open && 'hidden'
      )}
    >
      <InsightsOverlay />
    </div>
  );
};
